import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "./UserContext";
import "./css/Header.css";
import { FaBars, FaShoppingCart, FaBell } from "react-icons/fa";
import Navigation from "./Navigation";
import { Link } from "react-router-dom";
import Notifications from "./Notifications";

function Header({ onOpenCart, onOpenLogin, toggleNavigation }) {
  const { user, logout, cart, userPlan } = useUser();
  const [showNavigation, setShowNavigation] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const ADMIN_USER_ID = process.env.REACT_APP_ADMIN_USER_ID;
  const isAdminUser = user?.$id === ADMIN_USER_ID;
  const dropdownRef = useRef(null);
  const avatarRef = useRef(null);
  const notifWrapperRef = useRef(null);
  const navigate = useNavigate();

  const closeNavigation = () => {
    setShowNavigation(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "";
  };

  const handleClickOutside = (event) => {
    // Close user dropdown
    if (
      showDropdown &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      avatarRef.current &&
      !avatarRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
    }

    // Close notification dropdown
    if (
      showNotif &&
      notifWrapperRef.current &&
      !notifWrapperRef.current.contains(event.target)
    ) {
      setShowNotif(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown, showNotif]);

  return (
    <div className="header">
      <div className="header-main">
        <div className="header-2">
          <div className="logo">
            <Link to="/" className="logo-header">
              <img src="./assets/hxabyte-up.png" alt="logo-up" />
              <img src="./assets/hxabyte-down.png" alt="logo-down" />
            </Link>
          </div>

          <div className="user-cart-section">
            <div
              className="cart-icon"
              onClick={onOpenCart}
              style={{ marginLeft: "20px" }}
            >
              <FaShoppingCart />
              <p>{cart.length}</p>
            </div>

            <div className="user-info">
              {user && (
                <div className={`plan-badge plan-${userPlan || "trial"}`}>
                  <Link to="/plans">
                    {" "}
                    {userPlan === "producer"
                      ? "PRODUCER"
                      : userPlan === "creator"
                        ? "CREATOR"
                        : "TRIAL"}
                  </Link>
                </div>
              )}
              {user ? (
                <>
                  <div
                    className="user-avatar"
                    onClick={toggleDropdown}
                    ref={avatarRef}
                  >
                    {user.avatar ? (
                      <img
                        src={user.avatar}
                        alt={user.name}
                        className="avatar-img"
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      getInitial(user.name)
                    )}
                  </div>

                  {showDropdown && (
                    <div className="dropdown-menu" ref={dropdownRef}>
                      <div className="dropdown-header">
                        Welcome, {user.name}
                      </div>
                      <button
                        onClick={() => {
                          navigate("/purchased");
                          setShowDropdown(false);
                        }}
                      >
                        Purchased
                      </button>
                      <button
                        onClick={() => {
                          navigate("/your-products");
                          setShowDropdown(false);
                        }}
                      >
                        Your Products
                      </button>
                      <button
                        onClick={() => {
                          navigate("/offers");
                          setShowDropdown(false);
                        }}
                      >
                        Offers
                      </button>
                      <button
                        onClick={() => {
                          navigate("/sell-beat");
                          setShowDropdown(false);
                        }}
                      >
                        <div>Sell Beats</div>
                      </button>
                      <button
                        onClick={() => {
                          navigate("/sell-tutorials");
                          setShowDropdown(false);
                        }}
                      >
                        <div>Sell Tutorials</div>
                      </button>
                      <button
                        onClick={() => {
                          navigate("/sell-fashion");
                          setShowDropdown(false);
                        }}
                      >
                        <div>Sell Fashion & Merch</div>
                      </button>
                      <button
                        onClick={() => {
                          navigate("/profile-settings");
                          setShowDropdown(false);
                        }}
                      >
                        Profile Settings
                      </button>
                      <button
                        onClick={() => {
                          navigate("/contact-us");
                          setShowDropdown(false);
                        }}
                      >
                        Contact Us
                      </button>
                      {isAdminUser && (
                        <button
                          onClick={() => {
                            navigate("/admin");
                            setShowDropdown(false);
                          }}
                        >
                          Admin
                        </button>
                      )}

                      <button onClick={handleLogout}>Logout</button>
                    </div>
                  )}
                </>
              ) : (
                <button onClick={onOpenLogin} className="button-logout">
                  Login / Register
                </button>
              )}
            </div>

            <div className="notif-wrapper" ref={notifWrapperRef}>
              <div
                className="notif-icon"
                onClick={() => setShowNotif(!showNotif)}
              >
                <FaBell />
              </div>
              {showNotif && (
                <div className="notif-dropdown">
                  <Notifications />
                </div>
              )}
            </div>

            <FaBars className="menu-icon1" onClick={toggleNavigation} />
          </div>
        </div>

        <Navigation show={showNavigation} onClose={closeNavigation} />
      </div>
    </div>
  );
}

export default Header;
